module.exports = __webpack_public_path__ + "static/media/Neelesh.jpeg:Zone.ad0e0107.Identifier";